import { B as l } from "./chunk-BaseElement-BuXbltG-.js";
import { t as h } from "./chunk-custom-element-ttkHUa8w.js";
import { n as c } from "./chunk-property-Baio2yOX.js";
var b = Object.defineProperty, f = Object.getOwnPropertyDescriptor, o = (s, e, r, n) => {
  for (var t = n > 1 ? void 0 : n ? f(e, r) : e, a = s.length - 1, i; a >= 0; a--)
    (i = s[a]) && (t = (n ? i(e, r, t) : i(t)) || t);
  return n && t && b(e, r, t), t;
};
let d = class extends l {
  connectedCallback() {
    super.connectedCallback(), this.shuffleBrands(), this.renderBrands();
  }
  shuffleBrands() {
    if (this.brandsString && (this.brandsArr = JSON.parse(this.brandsString), !(!this.brandsArr || !this.brandsArr.length))) {
      for (let s = this.brandsArr.length - 1; s > 0; s--) {
        const e = Math.floor(Math.random() * (s + 1));
        [this.brandsArr[s], this.brandsArr[e]] = [
          this.brandsArr[e],
          this.brandsArr[s]
        ];
      }
      this.brandsArr = this.brandsArr.slice(0, 5);
    }
  }
  renderBrands() {
    const s = [];
    this.brandsArr.forEach((r) => {
      const n = r.replace(" ", "-").toLowerCase(), t = this.querySelector(`[data-handle='${n}']`);
      t && s.push(t);
    }), this.querySelectorAll("[data-brand]").forEach((r) => {
      (r.classList.contains("hidden") || r.classList.contains("invisible")) && r.remove();
    }), s.forEach((r) => {
      this.appendChild(r), r.classList.remove("hidden");
    }), this.classList.remove("opacity-0");
  }
};
o([
  c({ type: String, attribute: "data-brands" })
], d.prototype, "brandsString", 2);
d = o([
  h("brand-selector")
], d);
export {
  d as BrandSelector
};
